import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log("Mermaid controller connected")
    this.renderDiagrams()
  }

  renderDiagrams() {
    // Check if renderMermaid is available
    if (typeof window.renderMermaid === 'function') {
      console.log("Calling renderMermaid from controller")
      window.renderMermaid()
    } else {
      // If not available yet, try again in a moment
      console.log("renderMermaid not available yet, retrying...")
      setTimeout(() => {
        if (typeof window.renderMermaid === 'function') {
          window.renderMermaid()
        }
      }, 500)
    }
  }
}